import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IonClose from 'react-icons/lib/io/close';

import style from './style.css';

export const dialog_context = React.createContext();

export default class Dialog extends React.Component {

  static propTypes = {
    onClose: PropTypes.func.isRequired,
    closeOnBlur: PropTypes.bool.isRequired,
    width: PropTypes.oneOfType([
      PropTypes.number, PropTypes.string]),
    children: PropTypes.node.isRequired
  };

  static defaultProps = {
    closeOnBlur: true
  };

  constructor() {
    super(...arguments);
    this.state = {className: style.modal};
  }

  handleClose() {
    const {onClose} = this.props;
    this.setState({className: classNames(style.modal, style.closing)});
    setTimeout(onClose, 450);
  }

  handleModalClick(e) {
    const {closeOnBlur} = this.props;
    if (closeOnBlur && e.target.className === style.modal) {
      this.handleClose();
    }
  }

  render() {
    const {className} = this.state;
    let {children, width, ...props} = this.props;
    delete props.onClose;
    delete props.closeOnBlur;

    const addStyle = {};
    if (width) {
      addStyle.width = width;
    }

    return (
      <div {...props} className={className}
       onClick={this.handleModalClick.bind(this)}>
        <div className={style.dialog} style={addStyle}>
          <button
           type="button" role="button"
           name="close" onClick={this.handleClose.bind(this)}>
            <IonClose />
          </button>
          <div className={style.dialogContainer}>
            <dialog_context.Provider value={{closeDialog: this.handleClose.bind(this)}}>
              {children}
            </dialog_context.Provider>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/fragments/dialog/index.js